/**
 * StripCardElement Component
 */

import { getColorSchemeClassName } from '../../../styles/color-schemes';
import { bw6Hex, dangerousHex } from '../../../styles/colors';
import './styles.scss';

import * as classNames from 'classnames';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { CardElement } from 'react-stripe-elements';

import { isEqual } from 'lodash';
import Label, { LabelProps, Span } from '../../../atoms/text/Label';

interface IOwnProps {
  error?: string;
  className?: string;
  colorScheme?: 'light' | 'white';
  label?: string;
  note?: string;
  value?: string | { [objectKey: string]: string; };
}

interface IOwnState {
  error?: string;
  isFocus: boolean;
}

const classes = new BEM('stripe-card');
const labelClasses = new BEM('label');

export default class StripCardElement extends React.Component<IOwnProps, IOwnState> {
  static defaultProps: Partial<IOwnProps> = {
    colorScheme: 'light',
  };

  constructor(props) {
    super(props);

    this.state = {
      isFocus: false,
    };
  }

  componentWillReceiveProps({ error }: IOwnProps) {
    if (!isEqual(error, this.props.error)) {
      this.setState({ error });
    }
  }

  onToggleFocus = (isFocus: boolean) => {
    this.setState({ isFocus });
  }

  onChange = ({ error }: stripe.elements.ElementChangeResponse) => {
    this.setState({ error: error && error.message });
  }

  render() {
    const {
      className,
      colorScheme,
      label,
      note,
      value,
    } = this.props;

    const {
      error,
      isFocus,
    } = this.state;

    const modifiers = {
      'is-focus': isFocus,
      // 'is-disabled': disabled,
      // [size!]: size,
      'error': !!error,
      // 'warning': meta && meta.touched && meta.warning,
    };

    let noteLabel: JSX.Element | null = null;
    if (note != null) {
      const noteProps: LabelProps = {
        size: 'small',
        variant: 'note',
        ...classes('note'),
      };
      noteLabel = <Label {...noteProps}>{note || 'Optional'}</Label>;
    }

    const extraClasses = classNames(
      colorScheme && getColorSchemeClassName(colorScheme, 'stripe-card'),
      className,
    );

    /* tslint:disable-next-line */
    const shouldHidePostalCode = !!value && value.hasOwnProperty('postalCode') && value['postalCode'] !== '';

    return (
      <div {...classes('', modifiers, extraClasses) }>
        <div {...classes('background') } />
        {label && <Label text={label} size="small" {...classes('label') } />}
        {noteLabel}
        <CardElement
          {...classes('input') }
          hidePostalCode={shouldHidePostalCode}
          onFocus={() => this.onToggleFocus(true)}
          onBlur={() => this.onToggleFocus(false)}
          onChange={this.onChange}
          style={{
            base: {
              'fontFamily': 'Space Mono, monospace',
              'fontSize': '12px',
              'fontSmoothing': 'antialiased',
              '::placeholder': {
                color: bw6Hex,
              },
            },
            invalid: {
              color: dangerousHex,
              iconColor: dangerousHex,
            },
          }}
          value={shouldHidePostalCode ? value : {}}
        />
        {error && (
          <Span {...labelClasses('', 'error') } size="medium" textColor="dangerous">{error}</Span>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/molecules/forms/StripeCardElement/index.tsx